import { render, staticRenderFns } from "./QueueInfo.vue?vue&type=template&id=2f9d2bb7"
import script from "./QueueInfo.vue?vue&type=script&lang=ts"
export * from "./QueueInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports